module.exports = __webpack_public_path__ + "static/media/contact-hero.be7e6d9a.jpeg";